
export default ({request}) =>({
    //样品分类信息查询TreeList接口
  masSampleInputTemplateSelectTreeApi(data = {}) {
        return request({
            url: '/master/sampleInputTemplate/selectTree',
            method: 'post',
            data,
        })
    },
    masSampleInputTemplateCopySelectTreeApi(data = {}) {
        return request({
            url: '/master/sampleInputTemplate/copy/selectTree',
            method: 'post',
            data,
        })
    },
    masSampleInputTemplateCopyApi(data = {}) {
        return request({
            url: '/master/sampleInputTemplate/copy',
            method: 'post',
            data,
        })
    },
   //样品信息扩展字段输入模板信息列表查询
    masSampleInputTemplateRightListeApi(data = {}) {
        return request({
            url: '/master/sampleInputTemplate/rightList',
            method: 'post',
            data,
        })
    },
    //新增
    masSampleInputTemplateSaveApi(data = {}) {
        return request({
            url: '/master/sampleInputTemplate/save',
            method: 'post',
            data,
        })
    },

    //样品详情信息detail
    masSampleInputTemplateDetailApi(data = {}) {
        return request({
            url: '/master/sampleInputTemplate/detail',
            method: 'post',
            data,
        })
    },

    //样品分类删除
    masSampleInputTemplateDelApi(data = {}) {
        return request({
            url: '/master/sampleInputTemplate/del',
            method: 'post',
            data,
        })
    },

      //样品分类模板下拉
      masSampleInputTemplateSelectApi(data = {}) {
        return request({
            url: '/master/sampleInputTemplate/select',
            method: 'post',
            data,
        })
    },


})